import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button.jsx';

function Sidebar({ quickLinks = [], showSubmitCta = false }) {
  return (
    <aside className="space-y-6">
      {showSubmitCta && (
        <div className="bg-navy rounded-lg p-5 text-white">
          <h3 className="font-display text-lg font-semibold mb-2">Ready to Submit?</h3>
          <p className="font-sans text-slate-light text-sm mb-4 leading-relaxed">
            Share your research with a global audience. Review our author guidelines before submitting.
          </p>
          <Button to="/submit" variant="solid" color="amber" size="sm" className="w-full justify-center">
            Submit Manuscript
          </Button>
        </div>
      )}

      {quickLinks.length > 0 && (
        <div className="bg-white rounded-lg border border-bg-border p-5 shadow-sm">
          <h3 className="font-display text-base font-semibold text-navy mb-3">Quick Links</h3>
          <ul className="space-y-2">
            {quickLinks.map((link) => (
              <li key={link.to || link.href}>
                {link.to ? (
                  <Link
                    to={link.to}
                    className="flex items-center gap-2 font-sans text-sm text-slate hover:text-amber transition-colors"
                  >
                    <svg className="w-3.5 h-3.5 text-amber flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    {link.label}
                  </Link>
                ) : (
                  <a
                    href={link.href}
                    className="flex items-center gap-2 font-sans text-sm text-slate hover:text-amber transition-colors"
                  >
                    <svg className="w-3.5 h-3.5 text-amber flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    {link.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="bg-amber-tint rounded-lg border border-amber p-5">
        <h3 className="font-display text-base font-semibold text-navy mb-2">Contact Editorial Office</h3>
        <p className="font-sans text-sm text-amber-tinttext mb-2">
          For inquiries, please contact:
        </p>
        <a
          href="mailto:editor@jamsd.org"
          className="font-sans text-sm font-semibold text-amber hover:text-amber-dark transition-colors break-all"
        >
          editor@jamsd.org
        </a>
      </div>
    </aside>
  );
}

export default Sidebar;
